// extracted by mini-css-extract-plugin
export default {"melodyVideo":"rQ-z","isFullWidth":"sQ-z","landingPageVideo":"tQ-z","play":"uQ-z","iframeVideo":"vQ-z","playHidden":"wQ-z","fullwidth":"xQ-z"};